import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "./api";
import queryString from "query-string";

export const api = createApi({
  reducerPath: "bedRequestApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["BedRequest"],
  endpoints: (builder) => ({
    getBedRequests: builder.query({
      query: (filters) => `/bed-requests?${queryString.stringify(filters)}`,
      providesTags: ["BedRequest"],
    }),
    getBedRequest: builder.query({
      query: (id: string) => `/bed-requests/${id}`,
      providesTags: (result, error, id) => [{ type: "BedRequest", id }],
    }),
    createBedRequest: builder.mutation({
      query: (bedRequestData: any) => ({
        url: "/bed-requests",
        method: "POST",
        body: bedRequestData,
      }),
      invalidatesTags: ["BedRequest"],
    }),
    updateBedRequest: builder.mutation({
      query: ({ _id, ...updates }) => ({
        url: `/bed-requests/${_id}`,
        method: "PUT",
        body: updates,
      }),
      invalidatesTags: (result, error, { _id }) => [{ type: "BedRequest", _id }],
    }),
    deleteBedRequest: builder.mutation({
      query: (id: string) => ({
        url: `/bed-requests/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BedRequest"],
    }),
  }),
});

export const {
  useGetBedRequestsQuery,
  useGetBedRequestQuery,
  useCreateBedRequestMutation,
  useUpdateBedRequestMutation,
  useDeleteBedRequestMutation,
} = api;
